var BaseViews = require('../../../base');
var SearchOptionsItem = BaseViews.ItemView.extend({
    tagName: 'option',
    className: 'fmcy-search-options-item',
    template: require('./search-options-item/search-options-item.html'),
    initialize: function (options) {
        this.options = _.defaults(
            options || {},
            {
            }
        );
    },
    serializeData: function() {
        return {
            option: this.model.get('option')
        };
    },
    onRender: function() {
        this.$el.attr('id', this.model.get('id'));
    }
});
module.exports = SearchOptionsItem;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/subfilters/search-options/search-options-item.js
 **/